"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from "react";
import { FaXmark } from "react-icons/fa6";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import { usePathname } from "next/navigation";
import { Controls } from "@/app/[tenant]/(console)/scribe/playground/[id]/attachment-item";
import SelectPrimaryPatientModal from "@/components/tiptap/select-primary-patient-modal";
import { Dialog, DialogBody, DialogClose, DialogContent, DialogHeader, DialogTitle } from "@/components/ui";
import Button from "@/components/ui/button";
import { useChatConfigContext, useChatInputContext } from "./chat-context";
import { useChatModalsRefContext } from "./contexts";
import { useChatData } from "./hooks";
import { useUpdatePrimaryPatientMutation } from "@/query/comms/chat";
export function ChatModals() {
  const $ = _c(21);
  const pathname = usePathname();
  const {
    chatId
  } = useChatConfigContext();
  let t0;
  if ($[0] !== chatId) {
    t0 = {
      chatId
    };
    $[0] = chatId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    chat
  } = useChatData(t0);
  const {
    previewFileUrl,
    setPreviewFile
  } = useChatInputContext();
  const {
    chatModalsRef
  } = useChatModalsRefContext();
  const [showPrimaryPatientModal, setShowPrimaryPatientModal] = useState(false);
  let t1;
  let t2;
  if ($[2] !== pathname) {
    t1 = () => {
      if (pathname?.includes("/patient/merge")) {
        setShowPrimaryPatientModal(false);
      }
    };
    t2 = [pathname];
    $[2] = pathname;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  const updatePrimaryPatientMutation = useUpdatePrimaryPatientMutation();
  let t3;
  if ($[5] !== chat || $[6] !== updatePrimaryPatientMutation) {
    t3 = patientId => {
      if (!chat) {
        return;
      }
      updatePrimaryPatientMutation.mutate({
        chatId: chat.id,
        patientId
      });
    };
    $[5] = chat;
    $[6] = updatePrimaryPatientMutation;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleSetPrimaryPatient = t3;
  let t4;
  let t5;
  if ($[8] !== chatModalsRef) {
    t4 = () => {
      chatModalsRef.current = {
        openPrimaryPatientModal: () => {
          setShowPrimaryPatientModal(true);
        }
      };
      return () => {
        chatModalsRef.current = null;
      };
    };
    t5 = [chatModalsRef];
    $[8] = chatModalsRef;
    $[9] = t4;
    $[10] = t5;
  } else {
    t4 = $[9];
    t5 = $[10];
  }
  useEffect(t4, t5);
  let t6;
  if ($[11] !== chat || $[12] !== handleSetPrimaryPatient || $[13] !== showPrimaryPatientModal) {
    t6 = chat && <SelectPrimaryPatientModal isOpen={showPrimaryPatientModal} setIsOpen={setShowPrimaryPatientModal} chat={chat} onSelectPrimaryPatient={handleSetPrimaryPatient} />;
    $[11] = chat;
    $[12] = handleSetPrimaryPatient;
    $[13] = showPrimaryPatientModal;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== previewFileUrl || $[16] !== setPreviewFile) {
    t7 = previewFileUrl && <Dialog open={!!previewFileUrl} onOpenChange={open => {
      if (!open) {
        setPreviewFile(null);
      }
    }}><DialogContent className="h-screen max-h-screen w-screen max-w-none" onInteractOutside={_temp}><DialogHeader className="flex-row justify-end"><DialogTitle className="sr-only">Fullscreen Image</DialogTitle><DialogClose asChild={true}><Button variant="ghost" icon={<FaXmark size={20} />} /></DialogClose></DialogHeader><DialogBody className="m-0 p-0">{previewFileUrl && <div className="relative flex h-full w-full items-center justify-center overflow-hidden"><TransformWrapper>{() => <><Controls /><TransformComponent wrapperClass="!w-full !h-full" contentClass="!w-full !h-full items-center justify-center"><img src={previewFileUrl} alt="Full screen view" className="max-h-full max-w-full object-contain" /></TransformComponent></>}</TransformWrapper></div>}</DialogBody></DialogContent></Dialog>;
    $[15] = previewFileUrl;
    $[16] = setPreviewFile;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t6 || $[19] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}
function _temp(e) {
  return e.preventDefault();
}